export enum FormTypeValue {
  Download = 'download',
  Email = 'email',
}

export enum FieldNames {
  FormType = 'formType',
  Message = 'message',
  UserId = 'userId',
  CompletionGroupBy = 'completionGroupBy',
  // Custom renders
  Title1 = 'title1',
  Title2 = 'title2',
  Title3 = 'title3',
  ReportDetails = 'reportDetails',
}
